import { useState, useEffect } from 'react';
import { supabase } from '../../supabase/supabaseClient';
import { usePopupQueue } from '../ReusableComponents/usePopupQueue';
import MiniLoader from '../ReusableComponents/MiniLoader';
import "../../Styles/sharePopup.scss";

function Share({ onClose, palette, paletteDuo, paletteTrio, showDuo, showTrio, colorName, colorNameDuo, colorNameTrio, squareNames, paletteModifiers, paletteModifiersDuo, paletteModifiersTrio, color, colorDuo, colorTrio, selectedIndex, selectedIndexDuo, selectedIndexTrio }) {
  const [isLoading, setIsLoading] = useState(true);
  const [shareURL, setShareURL] = useState(null);
  const [copied, setCopied] = useState(false);
  const { activePopups, addPopup } = usePopupQueue();

  useEffect(() => {
    const generateLink = async () => {
      try {
        const paletteData = {
          palettes: {
            mono: { color, colorName, palette, squareNames, paletteModifiers, selectedIndex }
          },
          showDuo,
          showTrio
        };

        if (showDuo) {
          paletteData.palettes.duo = { color: colorDuo, colorName: colorNameDuo, palette: paletteDuo, squareNames, paletteModifiers: paletteModifiersDuo, selectedIndex: selectedIndexDuo };
        }

        if (showTrio) {
          paletteData.palettes.trio = { color: colorTrio, colorName: colorNameTrio, palette: paletteTrio, squareNames, paletteModifiers: paletteModifiersTrio, selectedIndex: selectedIndexTrio };
        }

        const { data, error } = await supabase
          .from('shared_palettes')
          .insert({ palette_data: paletteData })
          .select('id')
          .single();

        if (error) throw error;

        setShareURL(`${window.location.origin}/share/${data.id}`);
      } catch (error) {
        console.error('Error generating share link:', error);
      } finally {
        setIsLoading(false);
      }
    };

    generateLink();
  }, []);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(shareURL);
    setCopied(true);
    addPopup(`Copied link`);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="share-popup">
      <div className="content">
        <h4>Shareable link</h4>

        {isLoading ? (
          <>
            <div className="loader-addon"></div>
            <MiniLoader />
            <div className="loader-addon"></div>
          </>         
          
        ) : (
          <>
            <div className="link-container">
              <a target="_blank" className='link' href={shareURL}>{shareURL}</a>

              <svg className='newtab-icon' width={20} height={20} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
              </svg>
            </div>
            {/* <a target="_blank" className='link' href={shareURL}>{shareURL}</a>

            <svg className='newtab-icon' width={20} height={20} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
            </svg> */}

            <div className="btns-container">
              <button
                className={`copy-btn svg---text pri-btn btn-fixedW ${copied ? 'copied' : ''}`}
                onClick={handleCopy}
              >
                <svg className="copy-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
                  <path d="M3.7 12.7H2.8C2.32261 12.7 1.86477 12.5104 1.52721 12.1728C1.18964 11.8352 1 11.3774 1 10.9V2.8C1 2.32261 1.18964 1.86477 1.52721 1.52721C1.86477 1.18964 2.32261 1 2.8 1H10.9C11.3774 1 11.8352 1.18964 12.1728 1.52721C12.5104 1.86477 12.7 2.32261 12.7 2.8V3.7M9.1 7.3H17.2C18.1941 7.3 19 8.10589 19 9.1V17.2C19 18.1941 18.1941 19 17.2 19H9.1C8.10589 19 7.3 18.1941 7.3 17.2V9.1C7.3 8.10589 8.10589 7.3 9.1 7.3Z" stroke="#ffffff" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <svg className="checkmark-icon" width={18} height={18} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="#ffffff">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                </svg>
                <span>{copied ? 'Copied' : 'Copy link'}</span>
              </button>
            </div>

            {activePopups.length > 0 && (
              <div className="popup-timed-container centered">
                {activePopups.map((popup) => (
                  <div key={popup.id} className="popup-timed">
                    <div className="popup-timed-content">
                      <div className="svg---text">
                        {/* <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg> */}
                        <svg className="check-icon-fill" width={24} height={24} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                          <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
                        </svg>
                        <p>{popup.message}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Share;

